const alertMock = {
  errorServeur: `Désolé pour l'inconvénient rencontré. Il semble que nous rencontrons actuellement des problèmes techniques sur notre serveur de connexion. Nous travaillons actuellement à résoudre ce problème le plus rapidement possible.`,
  successStepOne:
    "Félicitations, vous venez d'identifier votre entreprise, nous allons passer à la deuxième étape de votre demande de crédit.",
};

export default alertMock;
